// extracted by mini-css-extract-plugin
module.exports = {"card":"ProductCard_card__ErxM3","card-img":"ProductCard_card-img__3S52Y"};